import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    // The panel's own labels are always English. The language picker chooses
    // which translation of the CONTENT a form edits — it must not translate
    // the field names around it (content team, 28 Oct 2026). No browser
    // detection either: a Hindi-language browser would otherwise switch them.
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;